export const images = {
  home: {
    header: "/images/homepage/header.jpg",
    images: [
      "/images/homepage/sacekimi.jpg",
      "/images/homepage/estetikveplastikcerrahi.jpg",
      "/images/homepage/obezitevemetabolikcerrahi.jpg",
      "/images/homepage/kbb.jpg",
      "/images/homepage/diş.jpg",
      "/images/homepage/göz.jpg",
      "/images/homepage/güzellikmerkezi.jpg",
      "/images/homepage/organizasyon.jpg",
    ],
  },
  sacEkimi: {
    header: "/images/sac-ekimi/sacekimi.jpg",
    images: [
      "/images/sac-ekimi/sacekimi1.jpg",
      "/images/sac-ekimi/sacekimi2.jpg",
      "/images/sac-ekimi/sacekimi3.jpg",
    ],
  },
  estetikVePlastikCerrahi: {
    header: "/images/plastik-cerrahi/plastikcerrahi.jpg",
    images: [
      "/images/plastik-cerrahi/burunestetigi1.jpg",
      "/images/plastik-cerrahi/ikincilburunestetiği2.jpg",
      "/images/plastik-cerrahi/tümvucutsekıllendırme3.jpg",
      "/images/plastik-cerrahi/brezilyapopoestetiği4.jpg",
      "/images/plastik-cerrahi/örümcekagıteknıgı5.jpg",
      "/images/plastik-cerrahi/yüzkaldırma6.jpg",
      "/images/plastik-cerrahi/gözkapagıameliaytı7.jpg",
      "/images/plastik-cerrahi/kolkaldırma8.jpg",
      "/images/plastik-cerrahi/bacakgerme9.jpg",
      "/images/plastik-cerrahi/karıngerme10.jpg",
      "/images/plastik-cerrahi/liposuction11.jpg",
      "/images/plastik-cerrahi/tümvucutgerme12.jpg",
      "/images/plastik-cerrahi/dudakkaldırma13.jpg",
      "/images/plastik-cerrahi/memebüyütme14.jpg",
      "/images/plastik-cerrahi/memekücültm15.jpg",
      "/images/plastik-cerrahi/memekaldırma16.jpg",
    ],
  },
  obeziteVeMetabolikCerrahi: {
    header: "/images/obezite-metabolik-cerrahi/obezitemetabolikcerrahi.jpg",
    images: ["/images/obezite-metabolik-cerrahi/obezite.jpg"],
  },
  agızVeDis: {
    header: "/images/agız-dis/agızvedis.jpg",
    images: [
      "/images/agız-dis/agızvedıs2.jpg",
      "/images/agız-dis/agızvedıs3.jpg",
    ],
  },
  kbb: {
    header: "/images/kbb/kbb.jpg",
    images: ["/images/kbb/kbb2.jpg"],
  },
  gozSaglıgı: {
    header: "/images/göz-saglıgı/gözsaglıgı.jpg",
    images: [
      "/images/göz-saglıgı/IntralaseLasik.jpg",
      "/images/göz-saglıgı/WavefrontLasik.jpg",
      "/images/göz-saglıgı/KataraktFakoMonofokalLens.jpg",
      "/images/göz-saglıgı/KataraktFakoTrifokalLens.jpg",
    ],
  },
  guzellikMerkezi: {
    header: "/images/güzellik-merkezi/güzellikmerkezi.jpg",
    images: [
      "/images/güzellik-merkezi/guzellık1.jpg",
      "/images/güzellik-merkezi/guzellık2.jpg",
      "/images/güzellik-merkezi/guzellık3.jpg",
      "/images/güzellik-merkezi/guzellık4.jpg",
    ],
  },
  organizasyonHizmetleri: {
    header: "/images/organizasyon-hizmetleri/organizasyonhizmetleri.jpg",
    images: [
      "/images/organizasyon-hizmetleri/organizasyonhizmetleri1.jpg",
      "/images/organizasyon-hizmetleri/organizasyonhizmetleri2.jpg",
      "/images/organizasyon-hizmetleri/organizasyonhizmetleri3.jpg",
      "/images/organizasyon-hizmetleri/organizasyonhizmetleri4.jpg",
    ],
  },
  aboutUs: {
    header: "/images/about-us/aboutus.jpg",
  },
  galeri: {
    header: "/images/galeri/gallery.jpg",
    images: [
      "/images/galeri/image1.jpg",
      "/images/galeri/image2.jpg",
      "/images/galeri/image3.jpg",
      "/images/galeri/image4.jpg",
      "/images/galeri/image5.jpg",
      "/images/galeri/image6.jpg",
      "/images/galeri/image7.jpg",
      "/images/galeri/image8.jpg",
      "/images/galeri/image9.jpg",
      "/images/galeri/image10.jpg",
      "/images/galeri/image11.jpg",
      "/images/galeri/image12.jpg",
      "/images/galeri/image13.jpg",
      "/images/galeri/image14.jpg",
      "/images/galeri/image15.jpg",
      "/images/galeri/image16.jpg",
    ],
  },
  contact: {
    header: "/images/contact-us/contact.jpg",
  },
};
